(function () {
  'use strict';

  var MIN_SAVE_MS = 380;
  var STAGE_OUT_MS = 320;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var INSTAGRAM_RE = /^[A-Za-z0-9._]{1,30}$/;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, prefersReducedMotion() ? 0 : ms);
    });
  }

  function formatUsPhone(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    digits = digits.slice(0, 10);
    if (!digits) return '';
    if (digits.length <= 3) return '(' + digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  function phoneDigits(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    return digits;
  }

  function track(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    } else if (typeof dataLayer !== 'undefined' && dataLayer.push) {
      dataLayer.push(Object.assign({ event: eventName }, params));
    }
    if (typeof posthog !== 'undefined' && typeof posthog.capture === 'function') {
      posthog.capture(eventName, params);
    }
  }

  function postJson(url, method, body) {
    var started = Date.now();
    return fetch(url, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(
          function (data) {
            return { ok: res.ok, status: res.status, data: data || {} };
          },
          function () {
            return { ok: res.ok, status: res.status, data: {} };
          }
        );
      })
      .then(function (result) {
        return wait(Math.max(0, MIN_SAVE_MS - (Date.now() - started))).then(function () {
          return result;
        });
      });
  }

  function initInvite(root) {
    var endpoint = (root.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
    var eventId = root.getAttribute('data-event') || '';
    var collectAddress = root.getAttribute('data-collect-address') === 'true';
    var collectEmail = root.getAttribute('data-collect-email') === 'true';
    var doneTitle = root.getAttribute('data-done-title') || "you're on the list";
    var doneBody = root.getAttribute('data-done-body') || '';

    var stages = {};
    root.querySelectorAll('[data-nr-hw-stage]').forEach(function (el) {
      stages[el.getAttribute('data-nr-hw-stage')] = el;
    });

    var rsvpForm = root.querySelector('[data-nr-hw-rsvp]');
    var inviteForm = root.querySelector('[data-nr-hw-invite]');
    var nameInput = root.querySelector('[data-nr-hw-name]');
    var phoneInput = root.querySelector('[data-nr-hw-phone]');
    var emailInput = root.querySelector('[data-nr-hw-email]');
    var consentInput = root.querySelector('[data-nr-hw-consent]');
    var skipBtn = root.querySelector('[data-nr-hw-skip]');

    var busy = false;
    var current = 'rsvp';
    var guest = { name: '', phone: '', token: '', alreadyRegistered: false };

    var video = root.querySelector('.nr-hw__media-video');
    if (video && prefersReducedMotion()) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    function messageEl(form) {
      return form.querySelector('[data-nr-hw-message]');
    }

    function showMessage(form, text, kind) {
      var el = messageEl(form);
      if (!el) return;
      el.hidden = !text;
      el.textContent = text || '';
      el.classList.toggle('nr-hw__message--error', kind === 'error');
    }

    function setBusy(form, isBusy) {
      busy = isBusy;
      form.classList.toggle('nr-hw__form--busy', isBusy);
      form.querySelectorAll('input, button').forEach(function (el) {
        el.disabled = isBusy;
      });
    }

    function goTo(name) {
      var from = stages[current];
      var to = stages[name];
      if (!to || name === current) return Promise.resolve();
      from.classList.add('nr-hw__stage--leaving');
      return wait(STAGE_OUT_MS).then(function () {
        from.hidden = true;
        from.classList.remove('nr-hw__stage--leaving');
        to.hidden = false;
        current = name;
        var focusEl = to.querySelector('input, button');
        if (focusEl && name !== 'done') focusEl.focus({ preventScroll: true });
      });
    }

    function finish() {
      var titleEl = root.querySelector('[data-nr-hw-done-title]');
      var bodyEl = root.querySelector('[data-nr-hw-done-body]');
      if (titleEl) titleEl.textContent = doneTitle;
      if (bodyEl) {
        bodyEl.textContent = doneBody;
        bodyEl.hidden = !doneBody;
      }
      // Optional secondary contact: only when we hold a token and email wasn't asked elsewhere.
      var extra = root.querySelector('[data-nr-hw-extra]');
      if (extra) extra.hidden = !(guest.token && !collectAddress && !collectEmail);
      return goTo('done');
    }

    var extraForm = root.querySelector('[data-nr-hw-extra-form]');
    if (extraForm) {
      extraForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        var input = extraForm.querySelector('[data-nr-hw-extra-email]');
        var msg = extraForm.querySelector('[data-nr-hw-extra-message]');
        var email = input ? input.value.trim() : '';
        function say(text, isError) {
          if (!msg) return;
          msg.hidden = !text;
          msg.textContent = text || '';
          msg.classList.toggle('nr-hw__message--error', !!isError);
        }
        if (!EMAIL_RE.test(email)) {
          say('please enter a valid email', true);
          return;
        }
        setBusy(extraForm, true);
        say('saving…');
        postJson(endpoint + '/api/rsvp/profile', 'POST', {
          phone: guest.phone,
          eventId: eventId,
          profileToken: guest.token,
          email: email,
        })
          .then(function (result) {
            setBusy(extraForm, false);
            if (!result.ok) {
              say(result.data.error || 'something went wrong — please try again', true);
              return;
            }
            track('rsvp_extra_email_saved', { event_id: eventId });
            extraForm.querySelectorAll('input, button').forEach(function (el) {
              el.hidden = true;
            });
            say('thanks, got it');
          })
          .catch(function () {
            setBusy(extraForm, false);
            say('network error — please try again', true);
          });
      });
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var formatted = formatUsPhone(phoneInput.value);
        if (formatted !== phoneInput.value) phoneInput.value = formatted;
      });
    }

    function submitRsvp() {
      if (busy) return;
      var name = (nameInput ? nameInput.value : '').trim().slice(0, 100);
      var digits = phoneDigits(phoneInput ? phoneInput.value : '');

      if (!name) {
        showMessage(rsvpForm, 'please enter your name', 'error');
        if (nameInput) nameInput.focus();
        return;
      }
      if (digits.length !== 10 || /^[01]/.test(digits)) {
        showMessage(rsvpForm, 'please enter a valid 10-digit number', 'error');
        if (phoneInput) phoneInput.focus();
        return;
      }
      var rsvpEmail = emailInput ? emailInput.value.trim().slice(0, 200) : '';
      if (collectEmail && !collectAddress && !EMAIL_RE.test(rsvpEmail)) {
        showMessage(rsvpForm, 'please enter a valid email', 'error');
        if (emailInput) emailInput.focus();
        return;
      }
      if (consentInput && !consentInput.checked) {
        showMessage(rsvpForm, 'please agree to receive messages', 'error');
        consentInput.focus();
        return;
      }
      if (!endpoint || !eventId) {
        showMessage(rsvpForm, 'rsvp is not configured yet', 'error');
        return;
      }

      guest.name = name;
      guest.phone = '+1' + digits;
      track('rsvp_form_submitted', { event_id: eventId });
      setBusy(rsvpForm, true);
      showMessage(rsvpForm, 'signing you up…');

      postJson(endpoint + '/api/rsvp', 'POST', {
        name: name,
        phone: guest.phone,
        eventId: eventId,
        consented: true,
      })
        .then(function (result) {
          var data = result.data;
          if (!result.ok) {
            setBusy(rsvpForm, false);
            showMessage(rsvpForm, data.error || 'something went wrong — please try again', 'error');
            return;
          }

          track('rsvp_form_success', { event_id: eventId });
          guest.alreadyRegistered = data.status === 'already_registered';
          guest.token = data.profileToken || '';

          // Already on the list with no name saved: the typed name wasn't stored by /api/rsvp.
          var namePatch = Promise.resolve();
          if (guest.alreadyRegistered && data.hasName === false) {
            namePatch = fetch(endpoint + '/api/rsvp/name', {
              method: 'PATCH',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ phone: guest.phone, eventId: eventId, name: name }),
            }).catch(function () {});
          }

          return namePatch
            .then(function () {
              // Email is collected on the first step; save it right away (best effort).
              if (collectAddress || !collectEmail || !guest.token || !rsvpEmail) return;
              return postJson(endpoint + '/api/rsvp/profile', 'POST', {
                phone: guest.phone,
                eventId: eventId,
                profileToken: guest.token,
                email: rsvpEmail,
              }).catch(function () {});
            })
            .then(function () {
              busy = false;
              showMessage(rsvpForm, '');
              return guest.token && collectAddress ? goTo('invite') : finish();
            });
        })
        .catch(function () {
          setBusy(rsvpForm, false);
          showMessage(rsvpForm, 'network error — please try again', 'error');
        });
    }

    function fieldValue(name) {
      var el = inviteForm.querySelector('[data-nr-hw-field="' + name + '"]');
      return el ? el.value.trim() : '';
    }

    function cleanInstagram(value) {
      return String(value || '')
        .trim()
        .slice(0, 200)
        .replace(/^https?:\/\/(www\.)?instagram\.com\//i, '')
        .replace(/^@+/, '')
        .replace(/\/.*$/, '');
    }

    function saveProfile(payload, path) {
      setBusy(inviteForm, true);
      showMessage(inviteForm, 'saving…');
      var body = Object.assign({ phone: guest.phone, eventId: eventId, profileToken: guest.token }, payload);

      return postJson(endpoint + '/api/rsvp/profile', 'POST', body)
        .then(function (result) {
          if (!result.ok) {
            setBusy(inviteForm, false);
            showMessage(inviteForm, result.data.error || 'something went wrong — please try again', 'error');
            return;
          }
          track('rsvp_profile_saved', { event_id: eventId, profile_path: path });
          showMessage(inviteForm, '');
          return finish();
        })
        .catch(function () {
          setBusy(inviteForm, false);
          showMessage(inviteForm, 'network error — please try again', 'error');
        });
    }

    function submitInvite() {
      if (busy) return;
      var email = fieldValue('email');
      if (email && !EMAIL_RE.test(email)) {
        showMessage(inviteForm, 'please enter a valid email', 'error');
        return;
      }

      if (!collectAddress) {
        if (email) {
          saveProfile({ email: email }, 'email');
        } else {
          finish();
        }
        return;
      }

      var line1 = fieldValue('line1');
      var city = fieldValue('city');
      var postal = fieldValue('postal');
      if (!line1 || !city || !postal || !email) {
        showMessage(inviteForm, 'please fill in your address and email', 'error');
        return;
      }

      var instagram = cleanInstagram(fieldValue('instagram'));
      if (instagram && !INSTAGRAM_RE.test(instagram)) {
        showMessage(inviteForm, 'please check your instagram handle', 'error');
        return;
      }

      var parts = guest.name.split(/\s+/);
      var payload = {
        firstName: parts.shift() || guest.name,
        lastName: parts.join(' '),
        email: email,
        line1: line1,
        line2: fieldValue('line2'),
        city: city,
        region: fieldValue('region'),
        postal: postal,
        country: 'US',
      };
      if (instagram) payload.instagram = instagram;
      saveProfile(payload, 'mail');
    }

    function skipInvite() {
      if (busy) return;
      var email = fieldValue('email');
      if (email && !EMAIL_RE.test(email)) {
        showMessage(inviteForm, 'please enter a valid email', 'error');
        return;
      }
      if (collectAddress) {
        saveProfile({ mailDeclined: true, email: email }, 'declined');
      } else if (email) {
        saveProfile({ email: email }, 'email');
      } else {
        finish();
      }
    }

    if (rsvpForm) {
      rsvpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        submitRsvp();
      });
    }

    if (inviteForm) {
      inviteForm.addEventListener('submit', function (e) {
        e.preventDefault();
        submitInvite();
      });
    }

    if (skipBtn) skipBtn.addEventListener('click', skipInvite);
  }

  function init() {
    document.querySelectorAll('[data-nr-hw]').forEach(initInvite);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
